<template>
    <v-sheet>
        <v-radio-group v-model="form.video.type" row hide-details @change="emit">
            <template v-for="item in types">
                <v-radio :label="item.text" :value="item.value" :key="item.value" />
            </template>
        </v-radio-group>
        <v-text-field v-model="form.video.link" placeholder="URL을 입력해주세요" v-bind="attrs_input" @input="emit" />
    </v-sheet>
</template>

<script>
import { LECTURE_VIDEO_TYPES } from "@/store/lecture/lecture.const";
import { initLecture } from "@/store/lecture/lecture.inits";
import { attrs_input } from "@/assets/variables";

const types = Object.values(LECTURE_VIDEO_TYPES);

export default {
    props: {
        value: { type: Object, default: initLecture },
    },
    data: () => ({
        form: initLecture(),

        types,
        attrs_input,
    }),
    methods: {
        sync() {
            this.form = initLecture(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style></style>
